import React, { ReactElement, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { Foundation } from '@philips-internal/oswald-ui-foundation';
import bootstrap from './app/bootstrap-foundation';
import { ThemeColor, ThemeService, ThemeTonalRange } from '@philips-internal/oswald-ui-components';

import '@philips-internal/oswald-ui-components';
import '@philips-emr/health-professional-components';

import './controllers';
import './index.css';

function RootApp(): ReactElement {
  useEffect(() => {
    ThemeService.setColors(ThemeColor.GROUP_BLUE, ThemeColor.GREEN);
    ThemeService.setContentTonalRange(ThemeTonalRange.ULTRA_LIGHT);
    ThemeService.setNavigationTonalRange(ThemeTonalRange.BRIGHT);
  },[])
  return (
    <Foundation
      bootstrap={bootstrap}
      root={{
        fragmentName: 'root',
      }}
    />
  );
}

const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(<RootApp />);
}

